// ** Redux Imports
import { combineReducers } from "redux";

// ** Reducers Imports
import auth from "./auth";
import navbar from "./navbar";
import layout from "./layout";
import chat from "@src/views/apps/chat/store/reducer";
import todo from "@src/views/apps/todo/store/reducer";
//import users from '@src/views/apps/contactos/store/reducer'
import email from "@src/views/apps/email/store/reducer";
import invoice from "@src/views/apps/cotizaciones/store/reducer";
//import calendar from '@src/views/apps/calendar/store/reducer'
import ecommerce from "@src/views/apps/ecommerce/store/reducer";
import dataTables from "@src/views/tables/data-tables/store/reducer";
import usersConductores from "@src/views/apps/conductores/store/reducer";
import usersServicios from "@src/views/apps/servicios/store/reducer";
import invoiceTransacciones from "@src/views/apps/transacciones/store/reducer";
import invoicePagos from "@src/views/apps/pagos/store/reducer";
import invoiceFacturas from "@src/views/apps/facturas/store/reducer";
import userMetas from "@src/views/apps/metas/store/reducer";

const rootReducer = combineReducers({
  auth,
  todo,
  chat,
  email,
  // users,
  navbar,
  layout,
  invoice,
  //calendar,
  ecommerce,
  dataTables,
  usersConductores,
  usersServicios,
  invoiceTransacciones,
  invoicePagos,
  invoiceFacturas,
  userMetas,
});

export default rootReducer;
